import { useMutation, useQueryClient } from "react-query";
import {
  getTransactionTemplate,
  parseTransactionUpload,
  updateGrantTransactions,
  validateTransactions,
} from "../api/bulkGrantUpdate";
import { ParsedTransactionRow } from "../types/BulkGrantUpdate";

/**
 * Hook to download the grant transaction template
 */
export function useGetTransactionTemplate() {
  return useMutation({
    mutationKey: "getTransactionTemplate",
    mutationFn: (grantIds?: string[]) => getTransactionTemplate(grantIds),
  });
}

/**
 * Hook to parse and validate uploaded transaction file
 */
export function useParseTransactionUpload() {
  return useMutation({
    mutationKey: "parseTransactionUpload",
    mutationFn: (file: string) => parseTransactionUpload(file),
  });
}

/**
 * Hook to update grant transactions in bulk
 */
export function useUpdateGrantTransactions() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: "updateGrantTransactions",
    mutationFn: (transactions: ParsedTransactionRow[]) =>
      updateGrantTransactions(transactions),
    onSuccess: () => {},
  });
}

/**
 * Hook to validate grant transactions in bulk
 */
export function useValidateTransactions() {
  return useMutation({
    mutationKey: "validateTransactions",
    mutationFn: (transactions: ParsedTransactionRow[]) =>
      validateTransactions(transactions),
  });
}
